import { Clock } from '@gravity-ui/icons';

/** 预览链接已失效（preview token 无效或过期）。 */
export function PreviewExpiredPage() {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-[#0a0a0a]">
      <div className="mx-4 flex max-w-sm flex-col items-center rounded-2xl bg-white/5 p-10 text-center backdrop-blur-md">
        <Clock width={48} height={48} className="mb-4 text-white/40" />
        <h1 className="text-xl font-semibold text-white">Preview Expired</h1>
        <p className="mt-2 text-sm text-white/60">
          This preview link has expired or is no longer valid. Please request a new one from the
          scene creator.
        </p>
        <a href="/" className="mt-6 rounded-full bg-white px-6 py-3 font-medium text-[#18181B]">
          Back to Home
        </a>
      </div>
    </div>
  );
}
